import React, { useEffect, useRef } from 'react'

import Loader from 'components/loader/loader'
import FormError from './formError'

import InputStandard from 'components/input/standard'
import CheckboxItem from 'components/input/checkbox-item'
import Select from 'components/input/select'
import BillingType from 'components/input/billing-type'
import CardInput from 'components/input/card-input'
import InviteList from 'components/input/invite-list'
import Address from 'components/input/address'
import AccountBox from 'components/input/account-box'

import Button from 'components/button/button'

export default ({
    handleSubmit,
    handleChange,
    rows,
    values,
    buttonPrimary,
    buttonLow,
    isLoading,
    error,
    isFocused
}) => {
    const inputRefs = useRef({})

    useEffect(() => {
        if(isFocused){
            setTimeout(() => {
                const inputRefsKeys = Object.keys(inputRefs.current)

                if(inputRefsKeys.length){
                    const firstInput = inputRefs.current[inputRefsKeys[0]]

                    if(firstInput){
                        firstInput.focus()
                    }
                }
            },1500)
        }
    },[isFocused])

    return (
        <div className={`form-container ${ isLoading ? 'loading' : '' }`}>
            <Loader visible={isLoading} />
                    <form
                        onSubmit={handleSubmit}
                    >
                        <FormError
                            error={error}
                        />
                        {rows.map((row, rowIndex) => {
                            return (
                                <div className={`form-row columns-${row.length}`} key={rowIndex}>
                                    {row.map((column, columnIndex) => {
                                        const {
                                            type,
                                            key,
                                            placeholder,
                                            props,
                                            subtitle,
                                            hidden,
                                            disabled
                                        } = column

                                        if(hidden){
                                            return null
                                        }

                                        let Component = null

                                        switch (type) {
                                            case 'text':
                                            case 'email':
                                            case 'password':
                                                Component = InputStandard
                                                break
                                            case 'address':
                                                Component = Address
                                                break
                                            case 'checkbox':
                                                Component = CheckboxItem
                                                break
                                            case 'select':
                                                Component = Select
                                                break
                                            case 'billingType':
                                                Component = BillingType
                                                break
                                            case 'cardInput':
                                                Component = CardInput
                                                break
                                            case 'inviteList':
                                                Component = InviteList
                                                break
                                            case 'accountBox':
                                                Component = AccountBox
                                                break

                                        }

                                        if (!Component) {
                                            return null
                                        }

                                        return (
                                            <div className={'input-wrap'} key={columnIndex}>
                                                <Component
                                                    placeholder={placeholder}
                                                    type={type}
                                                    outlineOnFocus
                                                    onChange={e => handleChange(key, e.target ? e.target.value : e)}
                                                    value={values[key] || ''}
                                                    innerRef={ref => {
                                                        inputRefs.current[rowIndex+'.'+columnIndex] = ref
                                                    }}
                                                    disabled={disabled}
                                                    {...props}
                                                />
                                                {subtitle &&
                                                    <span className={'subtitle'} dangerouslySetInnerHTML={{ __html: subtitle }} />
                                                }
                                            </div>
                                        )
                                    })}
                                </div>
                            )
                        })}
                        <div className="button-row">
                            {buttonPrimary &&
                                <Button
                                    size={'big'}
                                    level={'high'}
                                    callback={handleSubmit}
                                    label={buttonPrimary.label || 'Save details'}
                                    icon={'check'}
                                />
                            }
                            { buttonLow &&
                                <Button
                                    size={'big'}
                                    level={'x-low'}
                                    callback={buttonLow.callback}
                                    label={buttonLow.label}
                                />
                            }
                        </div>
                    </form>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/form/form.jsx